import { FC } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import ProcessReportInputsPanel from './ProcessReportInputsPanel';
import { ProcessReportModalProps } from './ProcessReportModal.props';
import { ProcessReportModalProvider } from './ProcessReportModalContext';
import ProcessReportOutputPanel from './ProcessReportOutputPanel';

const ProcessReportModal: FC<ProcessReportModalProps> = ({
  open,
  onClose,
  cmdId,
  valuationId,
  companyName,
  valuationFolderPath,
  existingReportReference,
}) => (
  <ProcessReportModalProvider
    open={open}
    cmdId={cmdId}
    valuationId={valuationId}
    companyName={companyName}
    valuationFolderPath={valuationFolderPath}
    existingReportReference={existingReportReference}>
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          width: 'min(1200px, 96vw)',
          maxWidth: '96vw',
        },
      }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span>Draft Final Report Email{companyName ? ` — ${companyName}` : ''}</span>
        <IconButton onClick={onClose} size="small" aria-label="close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
          <ProcessReportInputsPanel />
          <ProcessReportOutputPanel />
        </Box>
      </DialogContent>
    </Dialog>
  </ProcessReportModalProvider>
);

export default ProcessReportModal;
